import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

const ListItem = styled.li`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: baseline;
`

const NumberLabel = styled.span`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 300;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(var(--text-color), 0.35);
  margin-right: 1.5rem;
  flex-shrink: 0;
  width: 2rem;

  @media screen and (max-width: 480px) {
    display: none;
  }
`

const StyledLink = styled(Link)`
  font-family: 'Merriweather', serif;
  font-weight: 300;
  font-size: clamp(2.5rem, 5vw, 4.5rem);
  line-height: 1.3;
  color: rgb(var(--text-color));
  text-decoration: none;
  display: inline-block;
  transition:
    transform 0.3s ease,
    color 0.3s ease;

  &:visited {
    color: rgb(var(--text-color));
  }
  
  &.active {
    text-decoration: none;
    text-underline-offset: 0.15em;
    color: rgba(var(--text-color), 0.5);
  }

  &:hover {
    transform: translateX(1rem);
    color: rgba(var(--tltr-awesome-value), 1);
    text-decoration: none;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

const NavLink = ({ to, number, children, onClick, style }) => (
  <ListItem style={style}>
    <NumberLabel aria-hidden="true">{number}</NumberLabel>
    <StyledLink to={to} activeClassName="active" onClick={onClick}>
      {children}
    </StyledLink>
  </ListItem>
)

export default NavLink
